export function easeInCubic(x) {
    return Math.pow(x, 3);
}
